﻿import React, { PropsWithChildren } from "react";
import { observer } from "mobx-react";
import { injectFromApp } from "../inject";
import { UploadStatus } from "../../app-upload/FileUpload";
import type { IResourcesStore } from "../../resources/ResourcesStore";
import { assertUnreachable } from "../../util/assertions/assertUnreachable";

interface IProgressBarComponentProps {
    status: UploadStatus;
    progress: number;
    resourcesStore?: IResourcesStore;
    detailed?: boolean;
}

@injectFromApp<IProgressBarComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
}))

@observer
export class ProgressBarComponent extends React.Component<PropsWithChildren<IProgressBarComponentProps>> {
    private getStatusClassName(status: UploadStatus): string {
        switch (status) {
            case UploadStatus.ValidatingFiles:
                return "done";
            case UploadStatus.MaliciousContent:
                return "failed";
            case UploadStatus.NotADicomFile:
                return "failed";
            case UploadStatus.NotStarted:
                return "not-started";
            case UploadStatus.Done:
                return "done";
            case UploadStatus.Failed:
                return "failed";
            case UploadStatus.RateLimited:
                return "rate-limited";
            case UploadStatus.ExceededUploadSizeLimit:
                return "exceeded-upload-size-limit";
            case UploadStatus.IpBlocked:
                return "ip-blocked";
            case UploadStatus.UploadCodeExpired:
                return "upload-code-expired";
            case UploadStatus.Paused:
                return "paused";
            case UploadStatus.Started:
                return "started";
            case UploadStatus.Cancelled:
                return "cancelled";
            case UploadStatus.Queued:
                return "";
            default:
                return assertUnreachable(status);
        }
    }

    render() {
        const { props } = this;
        const { status, progress, resourcesStore } = props;
        const { resources } = resourcesStore!;

        return (
            <div className={"progress-bar-component " + this.getStatusClassName(status)}>
                <div className={"progress-bar-info"}>
                    <div className={"progress-title"}>
                        {this.props.children ? (
                            this.props.detailed ? (
                                <div className={"info"}>{this.props.children}</div>
                            ) : (
                                this.props.children
                            )
                        ) : (
                            <>
                                {status === UploadStatus.Paused && resources.Paused}
                                {status === UploadStatus.Started && resources.Uploading + "..."}
                            </>
                        )}
                    </div>
                    <div className={"progress-percentage"}>{progress.toFixed(0)}%</div>
                </div>
                <div className={"progress-bar"}>
                    <div style={{ width: progress.toFixed(0) + "%" }} className={"progress-percentage-bar"}>
                        &nbsp;
                    </div>
                </div>
            </div>
        );
    }
}
